export const XML_IMPORT_STORAGE_BUCKET = "fiscal-xml-imports";

interface XmlImportStorageNameInput {
  customerId: string;
  supplierName?: string | null;
  invoiceDate?: string | null;
  invoiceKey?: string | null;
}

const FALLBACK_SUPPLIER_NAME = "XML IMPORTADO";
const FALLBACK_DATE = "sem-data";

const sanitizeFilePart = (value: string) =>
  value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[\\/:*?"<>|]+/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .slice(0, 120);

const getDateParts = (value?: string | null) => {
  const match = value?.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!match) {
    return {
      folderDate: FALLBACK_DATE,
      displayDate: FALLBACK_DATE,
    };
  }

  const [, year, month, day] = match;
  return {
    folderDate: `${year}-${month}-${day}`,
    displayDate: `${day}-${month}-${year}`,
  };
};

export const buildXmlImportDownloadName = ({
  supplierName,
  invoiceDate,
}: XmlImportStorageNameInput) => {
  const issuer = sanitizeFilePart(supplierName || FALLBACK_SUPPLIER_NAME) || FALLBACK_SUPPLIER_NAME;
  const { displayDate } = getDateParts(invoiceDate);
  return `${issuer} - ${displayDate}.xml`;
};

export const buildXmlImportStoragePath = (input: XmlImportStorageNameInput) => {
  const issuer = sanitizeFilePart(input.supplierName || FALLBACK_SUPPLIER_NAME) || FALLBACK_SUPPLIER_NAME;
  const { folderDate, displayDate } = getDateParts(input.invoiceDate);
  const key = sanitizeFilePart(input.invoiceKey || crypto.randomUUID());
  return `${input.customerId}/xml-imports/${folderDate}/${issuer} - ${displayDate} - ${key}.xml`;
};
